import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"background":"#fff","overflow":"hidden"},
  class: "rounded-lg d-flex align-center justify-space-between"
}
const _hoisted_2 = {
  style: {"width":"30%"},
  class: "pr-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_setting_document_from_mail = _resolveComponent("setting-document-from-mail")!
  const _component_setting_payment = _resolveComponent("setting-payment")!
  const _component_setting_accounting_mail = _resolveComponent("setting-accounting-mail")!
  const _component_setting_je_declare = _resolveComponent("setting-je-declare")!
  const _component_setting_sobank = _resolveComponent("setting-sobank")!
  const _component_SettingExpenseAndIncome = _resolveComponent("SettingExpenseAndIncome")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, { "no-gutters": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          class: "pa-2"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_v_tabs, {
                modelValue: _ctx.type,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.type) = $event)),
                "background-color": "white",
                width: "100%",
                "fixed-tabs": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tab, {
                    value: "ALL",
                    class: "px-3"
                  }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createElementVNode("span", { class: "hidden-sm-and-down" }, "Tous", -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_tab, {
                    value: "BANK",
                    class: "px-3"
                  }, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createElementVNode("span", { class: "hidden-sm-and-down" }, "Banque", -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_tab, {
                    value: "MAIL",
                    class: "px-3"
                  }, {
                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createElementVNode("span", { class: "hidden-sm-and-down" }, "Mail", -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_tab, {
                    value: "PAYMENT",
                    class: "px-3"
                  }, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createElementVNode("span", { class: "hidden-sm-and-down" }, "Paiement", -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_tab, {
                    value: "OTHER",
                    class: "px-3"
                  }, {
                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                      _createElementVNode("span", { class: "hidden-sm-and-down" }, "Autre", -1)
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_v_text_field_filled, {
                  modelValue: _ctx.search,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
                  "append-inner-icon": "$search",
                  clearable: "",
                  label: "Rechercher",
                  outlined: "",
                  dense: "",
                  "hide-details": ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { "no-gutters": "" }, {
      default: _withCtx(() => [
        (_ctx.display('setting-document-from-mail'))
          ? (_openBlock(), _createBlock(_component_v_col, {
              key: 0,
              cols: "4",
              class: "d-flex my-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_setting_document_from_mail, {
                  ref: "setting-document-from-mail",
                  config: _ctx.config,
                  profileId: _ctx.profileId,
                  companyId: _ctx.companyId,
                  onUpdateProfile: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateProfile())),
                  onOnUpdate: _ctx.refresh
                }, null, 8, ["config", "profileId", "companyId", "onOnUpdate"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.display('setting-payment'))
          ? (_openBlock(), _createBlock(_component_v_col, {
              key: 1,
              cols: "4",
              class: "d-flex my-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_setting_payment, {
                  ref: "setting-payment",
                  config: _ctx.config,
                  companyId: _ctx.companyId,
                  onUpdateProfile: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateProfile()))
                }, null, 8, ["config", "companyId"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.display('setting-accounting-mail'))
          ? (_openBlock(), _createBlock(_component_v_col, {
              key: 2,
              cols: "4",
              class: "d-flex my-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_setting_accounting_mail, {
                  ref: "setting-accounting-mail",
                  config: _ctx.config,
                  profileId: _ctx.profileId,
                  companyId: _ctx.companyId,
                  onUpdateProfile: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateProfile())),
                  onOnUpdate: _ctx.refresh
                }, null, 8, ["config", "profileId", "companyId", "onOnUpdate"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.display('setting-je-declare'))
          ? (_openBlock(), _createBlock(_component_v_col, {
              key: 3,
              cols: "4",
              class: "d-flex my-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_setting_je_declare, {
                  ref: "setting-je-declare",
                  config: _ctx.config,
                  JDCConnectionOnTest: _ctx.JDCConnectionOnTest,
                  JDCConnectionTestSuccess: _ctx.JDCConnectionTestSuccess,
                  onUpdateProfile: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateProfile()))
                }, null, 8, ["config", "JDCConnectionOnTest", "JDCConnectionTestSuccess"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.display('setting-sobank'))
          ? (_openBlock(), _createBlock(_component_v_col, {
              key: 4,
              cols: "4",
              class: "d-flex my-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_setting_sobank, {
                  ref: "setting-sobank",
                  config: _ctx.config,
                  JDCConnectionOnTest: _ctx.JDCConnectionOnTest,
                  JDCConnectionTestSuccess: _ctx.JDCConnectionTestSuccess,
                  onUpdateProfile: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateProfile()))
                }, null, 8, ["config", "JDCConnectionOnTest", "JDCConnectionTestSuccess"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.display('setting-expense-and-income'))
          ? (_openBlock(), _createBlock(_component_v_col, {
              key: 5,
              cols: "4",
              class: "d-flex my-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SettingExpenseAndIncome, {
                  ref: "setting-expense-and-income",
                  config: _ctx.config,
                  onUpdateProfile: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateProfile()))
                }, null, 8, ["config"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}